import { FaHeart } from 'react-icons/fa';
import React from 'react';
import AudioControl from './AudioControl';

const Footer = () => {
  return (
    <footer className="py-8 px-4 bg-gray-100 text-center">
      <div className="max-w-4xl mx-auto">
        <div className="flex justify-center gap-6 mb-4">
          <AudioControl />
        </div>

        <p className="text-gray-600 text-sm">
          {/* Made with <FaHeart className="inline text-rose-500" /> by KetutWeb • © 2025 */}
        </p>
      </div>
    </footer>
  );
};

export default Footer;